module.exports = __webpack_public_path__ + "static/media/tyler-rosonke-full.34329a9a.jpg";